<template>
  <div class="electronic-receipt">
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      @close="handleClose"
      width="1060px"
    >
      <div class="header">
        <img src="@/assets/image/common/logo.png" alt="" srcset="">
      </div>
      <div class="content">
        <div class="title">
          <p>{{ titleEn }}</p>
          <p v-if="version === 'EN_CN'">{{ titleZh }}</p>
        </div>
        <div style="margin-bottom: 20px;">
          <div class="content-header content-header1">
            <div class="content-header-message">
              <span style="width: 115px;">Reference NO.</span> {{ detail.receiptNo }}
            </div>
            <div class="content-header-message">
              <span style="width: 150px;">Number of Downloads</span> {{ detail.clientDownload }}
            </div>
          </div>
          <div v-if="version === 'EN_CN'" class="content-header content-header2">
            <div class="content-header-message">
              <span style="width: 115px;">电子回单流水号</span> {{ detail.receiptNo }}
            </div>
            <div class="content-header-message">
              <span style="width: 50px;">已下载</span>  {{ detail.clientDownload }}次
            </div>
          </div>
        </div>
        <ul>
          <li v-for="(item, index) in list" :key="index">
            <div class="title">
              <span v-if="version === 'EN_CN'">{{ item.titleZh }}</span> {{ item.titleEn }}
            </div>
            <ol>
              <li
                v-for="(message, messageIndex) in item.children"
                :key="messageIndex"
                :class="{'full': message.full}"
              >
                <div class="message-item-label">
                  <span>{{ message.labelEn }}</span>
                  <span v-if="version === 'EN_CN'">{{ message.labelZh }}</span>
                </div>
                <div class="message-item-value">
                  {{ detail[message.value] | infoFormat(self, message.value) }}
                </div>
              </li>
            </ol>
          </li>
        </ul>
        <div class="intro">
          <div class="intro-left">
            <span>Notice: The same serial number of the electronic receipt indicates the same Remittance Advice. Please do not use it repeatedly for bookkeeping.</span>
            <span v-if="version === 'EN_CN'">提示：电子回单流水号相同表示同一笔业务回单，请勿重复记账使用。</span>
          </div>
          <div class="intro-right">
            <img src="@/assets/image/common/cbi-seal.png" alt="" srcset="">
          </div>
        </div>
        <div class="bottom">
          <span>{{ $t('版本') }}:</span>
          <el-select
            style="width: 120px"
            v-model="version">
            <el-option
              v-for="(item, index) in versionList"
              :key="index"
              :label="$t(item.name)"
              :value="item.value" />
          </el-select>
          <div v-if="detail.clientDownload === 0 || detail.clientDownload < 5" class="btns">
            <el-button class="btn140" type="primary" @click="download">{{ $t('下载回单') }}</el-button>
            <el-button class="btn140" type="primary" @click="sendVisible = true">{{ $t('发送至邮箱') }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('CBiBank电子回单')"
      :visible.sync="sendVisible"
      :close-on-click-modal="false"
      @close="sendFormData.email = ''; sendVisible = false"
      width="720px"
    >
      <el-form
        ref="sendForm"
        :model="sendFormData"
        :rules="rules"
        label-width="110px"
        label-position="left">
        <div class="split-tips">
          {{ $t('请填写邮箱进行申请') + '：' }}
        </div>
        <el-form-item
          :label="$t('电子邮箱')"
          prop="email">
          <el-input v-model="sendFormData.email" :placeholder="$t('请填写准确的邮箱')" type="text" />
        </el-form-item>
      </el-form>
      <div class="payee-list-filter-btns">
        <el-button class="search" type="primary" :loading="downloadLoading" @click="sendEmail">{{ $t('提交') }}</el-button>
        <el-button class="reset" @click="sendVisible = false">{{ $t('取消') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import transactionDetailApi from '../api/transactionDetailApi'
import { mapState } from 'vuex'
import { downloadBlob } from '@/utils/utils'

export default {
  props: {
    visible: { // 控制显示隐藏
      type: Boolean,
      default: false
    },
    detail: { // 详情
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      self: this,
      version: 'EN_CN',
      versionList: [
        { name: '中英文', value: 'EN_CN' },
        { name: 'English', value: 'EN' }
      ],
      transferOutList: [
        {
          titleEn: 'Originator Information',
          titleZh: '汇款信息',
          children: [
            { labelEn: 'Originator Name', labelZh: '汇款人名称', value: 'paymentName' },
            { labelEn: 'Originator Account No.', labelZh: '汇款账号', value: 'paymentAcc' },
            { labelEn: 'Remittance Amount', labelZh: '汇款金额', value: 'paymentAmount' },
            { labelEn: 'Date', labelZh: '汇款日期', value: 'transDate' }
          ]
        },
        {
          titleEn: 'Beneficiary Information',
          titleZh: '收款信息',
          children: [
            { labelEn: 'Beneficiary Name', labelZh: '收款人', value: 'receiptName' },
            { labelEn: 'Beneficiary Account No.', labelZh: '收款账号', value: 'receiptAcc' },
            { labelEn: 'Beneficiary Bank Name', labelZh: '收款银行名称', value: 'receiptBankName' },
            { labelEn: 'Beneficiary Bank SWIFT/ABA', labelZh: '收款银行SWIFT/ABA', value: 'receiptBankSwift' },
            { labelEn: 'Beneficiary Bank Address', labelZh: '收款银行地址', value: 'receiptBankAddr', full: true },
            { labelEn: 'Remittance Information', labelZh: '汇款附言', value: 'postScript', full: true }
          ]
        },
        {
          titleEn: 'Correspondent Information',
          titleZh: '代理行信息',
          children: [
            { labelEn: 'Correspondent Bank Name', labelZh: '代理行名称', value: 'correspondentName' },
            { labelEn: 'Correspondent Bank SWIFT', labelZh: '代理行SWIFT', value: 'correspondentSwift' },
            { labelEn: 'Correspondent Bank Address', labelZh: '代理行地址', value: 'correspondentAddr', full: true }
          ]
        },
        {
          titleEn: 'Other Information',
          titleZh: '其他信息',
          children: [
            { labelEn: 'Details of Charges', labelZh: '手续费支付方式', value: 'feeMethod' },
            { labelEn: 'Charge Amount', labelZh: '手续费金额', value: 'fee' }
          ]
        },
        {
          titleEn: 'Settlement Information',
          titleZh: '清算信息',
          children: [
            { labelEn: 'VIBAN', labelZh: 'VIBAN', value: 'viban' },
            { labelEn: 'Transaction Date', labelZh: '银行汇款时间', value: 'transferDate' }
          ]
        },
        {
          titleEn: 'Transaction Track Information',
          titleZh: '交易跟踪信息',
          children: [
            { labelEn: 'Transaction Maker', labelZh: '经办人员', value: 'maker' },
            { labelEn: 'Transaction Time', labelZh: '时间', value: 'makeTime' },
            { labelEn: 'Transaction Checker', labelZh: '复核人员', value: 'checker' },
            { labelEn: 'Transaction Time', labelZh: '时间', value: 'checkTime' }
          ]
        }
      ],
      transferInList: [
        {
          titleEn: 'Originator Information',
          titleZh: '汇款信息',
          children: [
            { labelEn: 'Originator Name', labelZh: '汇款人名称', value: 'paymentName' },
            { labelEn: 'Originator Account No.', labelZh: '汇款账号', value: 'paymentAcc' },
            { labelEn: 'Remittance Amount', labelZh: '汇款金额', value: 'paymentAmount' },
            { labelEn: 'Originating Bank SWIFT/ABA', labelZh: '汇款行SWIFT/ABA', value: 'paymentBankSwift' },
            { labelEn: 'Originating Bank Name', labelZh: '汇款银行名称', value: 'paymentBankName' },
            { labelEn: 'Remittance Information', labelZh: '汇款附言', value: 'postScript' }
          ]
        },
        {
          titleEn: 'Beneficiary Information',
          titleZh: '收款信息',
          children: [
            { labelEn: 'Beneficiary Name', labelZh: '收款人名称', value: 'receiptName' },
            { labelEn: 'Beneficiary Account No.', labelZh: '收款账号', value: 'receiptAcc' },
            { labelEn: 'Beneficiary Bank Name', labelZh: '收款银行名称', value: 'receiptBankName' },
            { labelEn: 'Value Date', labelZh: '汇入到账日期', value: 'transDate' }
          ]
        }
      ],
      payList: [
        {
          titleEn: 'Payment Information',
          titleZh: '缴费信息',
          children: [
            { labelEn: 'Originator Name', labelZh: '付款人名称', value: 'paymentName' },
            { labelEn: 'Originator Account No.', labelZh: '汇款账号', value: 'paymentAcc' },
            { labelEn: 'Transaction Amount', labelZh: '交易金额', value: 'paymentAmount' },
            { labelEn: 'Transaction Date', labelZh: '交易日期', value: 'transDate' },
            { labelEn: 'Payment Type', labelZh: '缴费类型', value: 'transType', full: true }
          ]
        }
      ],
      sendVisible: false,
      sendFormData: {
        email: ''
      },
      downloadLoading: false
    }
  },
  created () {},
  computed: {
    ...mapState('app', ['lang']),
    rules () {
      return {
        email: [
          { required: true, message: this.$t('请输入'), trigger: 'blur' }
        ]
      }
    },

    list () {
      if (this.detail.receiptType === '0') return this.transferOutList
      else if (this.detail.receiptType === '1') return this.transferInList
      else if (this.detail.receiptType === '2') return this.payList
      return []
    },
    titleEn () {
      if (this.detail.receiptType === '0') return 'CBiBank Outward Remittance Advice'
      else if (this.detail.receiptType === '1') return 'CBiBank Inward Remittance Advice'
      else if (this.detail.receiptType === '2') return 'CBiBank Payment Advice'
      return ''
    },
    titleZh () {
      if (this.detail.receiptType === '0') return 'CBiBank 汇出汇款通知单'
      else if (this.detail.receiptType === '1') return 'CBiBank 汇入汇款通知单'
      else if (this.detail.receiptType === '2') return 'CBiBank 缴费通知单'
      return ''
    }
  },
  filters: {
    infoFormat (row, self, value) {
      if (value === 'transType' || value === 'transTypeEn') {
        if (self.version === 'EN' || self.lang === 'en') {
          return self.detail.transTypeEn || '--'
        }
      }
      return row || '--'
    }
  },
  methods: {
    // 下载
    download () {
      this.downloadLoading = true
      transactionDetailApi.downloadEreceipt({
        receiptNo: this.detail.receiptNo,
        languageType: this.version
      }).then(res => {
        this.downloadLoading = false
        if (res) {
          const { receiptType } = this.detail
          const prefixName = this.$i18n.locale === 'zh-CN' ? 'CBiBank电子回单' : `CBiBank_${this.$t('电子回单')}`
          const suffixName = receiptType === '0' ? '汇出' : receiptType === '1' ? '汇入' : '缴费'
          downloadBlob(res, {
            filename: `${prefixName}_${this.detail.receiptNo}_${this.$t(suffixName)}`,
            ext: 'pdf'
          })
          this.$success('下载成功')
          this.confirmDownloadVisible = false
        }
      }).catch(err => {
        console.log(err)
        this.downloadLoading = false
      })
    },
    // 发送到邮箱
    sendEmail () {
      this.$refs.sendForm.validate(valide => {
        if (valide) {
          transactionDetailApi.singleReceiptSend({
            email: this.sendFormData.email,
            receiptId: this.detail.receiptNo,
            languageType: this.version
          }).then(res => {
            if (res) {
              this.$success('邮件已发送，请注意查收')
              this.sendVisible = false
            }
          })
        }
      })
    },
    // 关闭弹窗回调
    handleClose () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
  .electronic-receipt {
    .split-tips {
      color: #333752;
      margin: 30px 0;
      font-size: 14px;

      &:nth-child(1) {
        font-size: 16px;
        margin-top: 0;
      }
    }

    .payee-list-filter-btns {
      margin: 40px 0 30px;
      display: flex;
      justify-content: center;

      .search, .reset {
        min-width: 140px;
      }
    }

    .bottom {
      padding-top: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid #F6F7FC;

      .btns {
        display: flex;
        align-items: center;
        margin-left: 20px;

        .btn140 {
          min-width: 140px;
        }
      }

      span {
        font-size: 14px;
        font-weight: 300;
        color: #333752;
        margin-right: 16px;
      }
    }

    .content {
      border-top: 1px solid #E6E9F4;
      padding-top: 40px;

      .intro {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 10px;
        margin: 40px 0;

        .intro-left {
          display: flex;
          width: 500px;
          flex-direction: column;
          justify-content: center;
          font-size: 13px;
          font-weight: 400;
          color: #A1A7C4;
          line-height: 18px;

          span:nth-child(1) {
            margin-bottom: 20px;
          }
        }

        .intro-right {
          width: 159px;
          height: 106px;

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }

      ul {
        > li {
          .title {
            display: flex;
            align-items: center;
            padding-left: 20px;
            height: 50px;
            background: #F6F7FC;
            font-size: 14px;
            font-weight: 400;
            color: #161D29;
            line-height: 20px;

            span {
              margin-right: 6px;
            }
          }

          ol {
            display: flex;
            flex-wrap: wrap;

            li {
              width: 50%;
              padding: 14px 20px;
              border-bottom: 1px solid #F6F7FC;
              display: flex;
              align-items: center;

              &.full {
                width: 100%;
              }

              .message-item-value {
                font-size: 13px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 300;
                color: #5A607F;
                line-height: 16px;
                flex: 1 1 0%;
              }

              .message-item-label {
                display: flex;
                flex-direction: column;
                width: 200px;
                margin-right: 10px;

                span {
                  font-size: 13px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 300;
                  color: #333752;
                  line-height: 16px;
                }
              }
            }
          }
        }
      }

      .content-header {
        display: flex;
        padding: 0 20px;
        align-items: center;
        justify-content: space-between;
        color: #333752;
        font-size: 13px;
        line-height: 18px;

        .content-header-message {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        span {
          color: #5A607F;
          display: flex;
        }
      }

      > .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333752;
        margin-bottom: 20px;

        p {
          text-align: center;
          line-height: 30px;
        }
      }
    }

    .header {
      height: 50px;

      img {
        width: 106px;
        height: 30px;
        margin-top: -50px;
        display: block;
      }
    }
  }
</style>
